export default "__VITE_ASSET__98a7c8d1__"